<template>
  <span>
    <button
      type="button"
      class="bcsv-btn bcsv-btn--sm"
      :class="copied ? 'bcsv-btn--ok' : toneClass"
      @click="copy">
      <svg
        width="13"
        height="13"
        viewBox="0 0 14 14"
        fill="none"
        stroke="currentColor"
        stroke-width="1.5">
        <rect
          x="4.5"
          y="4.5"
          width="7.5"
          height="7.5"
          rx="1.5" />
        <path d="M9.5 4.5V3a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v5.5a1 1 0 0 0 1 1h1.5" />
      </svg>
      {{ copied ? 'คัดลอกแล้ว' : label }}
    </button>

    <v-dialog
      v-model="showFallback"
      max-width="620">
      <div class="bcsv bcsv--bare">
        <div
          class="bcsv-card"
          style="border-radius: 14px;">
          <div class="bcsv-modal-head">
            <div>
              <h2>คัดลอกอัตโนมัติไม่ได้</h2>
              <div
                class="bcsv-sub"
                style="margin-top: 4px; font-size: 13px;">
                เบราว์เซอร์ไม่อนุญาตให้เขียนคลิปบอร์ด — เลือกข้อความด้านล่างแล้วกด Ctrl/Cmd + C
              </div>
            </div>
            <button
              type="button"
              class="bcsv-x"
              @click="showFallback = false">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                stroke="currentColor"
                stroke-width="1.6">
                <path d="M3.5 3.5l9 9M12.5 3.5l-9 9" />
              </svg>
            </button>
          </div>
          <div style="padding: 18px 22px;">
            <textarea
              ref="fallbackText"
              class="bcsv-mono bcsv-fallback-text"
              readonly
              :value="prompt"
              @focus="selectAll" />
          </div>
          <div class="bcsv-modal-foot bcsv-modal-foot--end">
            <button
              type="button"
              class="bcsv-btn"
              @click="showFallback = false">
              ปิด
            </button>
          </div>
        </div>
      </div>
    </v-dialog>
  </span>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'BatchTransferCopyPromptButton',
  props: {
    prompt: {
      type: String,
      required: true
    },
    label: {
      type: String,
      default: 'Copy prompt สำหรับ AI'
    },
    tone: {
      type: String,
      default: 'accent'
    }
  },
  data () {
    return {
      copied: false,
      showFallback: false,
      resetTimer: null
    }
  },
  computed: {
    toneClass () {
      return this.tone === 'danger' ? 'bcsv-btn--danger' : 'bcsv-btn--ghost'
    }
  },
  beforeDestroy () {
    clearTimeout(this.resetTimer)
  },
  methods: {
    ...mapActions({
      setSnackbar: 'Components/setSnackbar'
    }),
    async copy () {
      const ok = await this.copyToClipboard(this.prompt)

      if (!ok) {
        // FR-9.1 — fallback สุดท้ายคือโชว์ข้อความให้ผู้ใช้ copy เอง ไม่ปล่อยให้เงียบ
        this.showFallback = true
        return
      }

      this.copied = true
      this.setSnackbar({
        value: true,
        message: 'คัดลอก prompt แล้ว — วางในแชท AI ได้เลย',
        type: 'success',
        timeout: 3200
      })

      clearTimeout(this.resetTimer)
      this.resetTimer = setTimeout(() => {
        this.copied = false
      }, 2000)
    },
    async copyToClipboard (text) {
      if (navigator.clipboard && window.isSecureContext) {
        try {
          await navigator.clipboard.writeText(text)
          return true
        } catch (error) {
          console.warn('clipboard.writeText failed, falling back', error)
        }
      }

      const textarea = document.createElement('textarea')
      textarea.value = text
      textarea.style.position = 'fixed'
      textarea.style.opacity = '0'
      document.body.appendChild(textarea)
      textarea.focus()
      textarea.select()

      let success = false
      try {
        success = document.execCommand('copy')
      } catch (error) {
        console.warn('execCommand copy failed', error)
      }
      document.body.removeChild(textarea)

      return success
    },
    selectAll () {
      const el = this.$refs.fallbackText
      if (el) el.select()
    }
  }
}
</script>

<style>
.bcsv-modal-foot--end {
  justify-content: flex-end;
}

.bcsv-fallback-text {
  width: 100%;
  height: 260px;
  resize: vertical;
  font-size: 12px;
  line-height: 1.6;
  color: #1F2A37;
  background: #FAFBFC;
  border: 1px solid #D6DBE1;
  border-radius: 10px;
  padding: 12px 14px;
  outline: none;
}
</style>
